import { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import Config from '../../../config';
import { format, startOfDay, addHours } from 'date-fns';

const useAssignCourse = () => {
    const { isedit } = useParams();
    const navigate = useNavigate();
    const [assignmentType, setAssignmentType] = useState(null);
    const [selectedDepartments, setSelectedDepartments] = useState([]);
    const [selectedEmployees, setSelectedEmployees] = useState([]);
    const [difficulty, setDifficulty] = useState('');
    const [exams, setExams] = useState([]);
    const [scheduleDate, setScheduleDate] = useState(format(addHours(startOfDay(new Date()), 9), "yyyy-MM-dd'T'HH:mm"));
    const [expiryDate, setExpiryDate] = useState(format(addHours(startOfDay(new Date()), 18), "yyyy-MM-dd'T'HH:mm"));
    const [oneTimeUsers, setOneTimeUsers] = useState([]);
    const [confirmOpen, setConfirmOpen] = useState(false);
    const [confirmationType, setConfirmationType] = useState('');
    const [successOpen, setSuccessOpen] = useState(false);
    const [difficulties, setDifficulties] = useState(null);
    const [difficultyId, setDifficultyId] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const [selectedExam, setSelectedExam] = useState('');
    const [selectedExamId, setSelectedExamId] = useState(null);
    const [departments, setDepartments] = useState([]);
    const [assignedData, setAssignedData] = useState([]);
    const [assignments, setAssignments] = useState([]);
    const [selectedAssignmentId, setSelectedAssignmentId] = useState(null);
    const [individuals, setIndividuals] = useState([]);
    const [selectedExamDuration, setSelectedExamDuration] = useState(null);
    const [oneTimeEmployees, setOneTimeEmployees] = useState([]);

    const [workStart, setWorkStart] = useState("09:00:00");
    const [workEnd, setWorkEnd] = useState("18:00:00");

    useEffect(() => {
        const fetchCategoriesAndDifficulties = async () => {
            setIsLoading(true);
            setError(null);
            try {
                const [difficultiesResponse] = await Promise.all([
                    axios.get(`/coordinators/difficulty/`),
                ]);
                const difficultiesData = Array.isArray(difficultiesResponse.data.data)
                    ? difficultiesResponse.data.data.map(diff => ({
                        id: diff.ID,
                        name: diff.Level,
                    }))
                    : [];
                setDifficulties(difficultiesData);
            } catch (error) {
                setError("Failed to load categories or difficulties. Please try again later.");
            } finally {
                setIsLoading(false);
            }
        };
        fetchCategoriesAndDifficulties();
    }, []);

    // useEffect(() => {
    //     const fetchDepartments = async () => {
    //         try {
    //             const res = await axios.get(`/coordinators/departments-list/`);
    //             const data = res.data?.data || [];
    //             const formatted = data.map(dept => ({
    //                 id: dept.Id,
    //                 name: dept.Name,
    //                 guid:dept.DepartmentGUID,
    //                 status: "Pending"
    //             }));
    //             setDepartments(formatted);
    //         } catch (err) {
    //             setError('Failed to fetch departments. Please try again later.');
    //         }
    //     };
    //     fetchDepartments();
    // }, []);

    useEffect(() => {
        const fetchDepartments = async () => {
            try {
                const res = await axios.get(`/coordinators/departments-list/`, {
                    params: {
                        page: 1,
                        page_size: 10,
                    },
                });

                const data = res.data?.data || [];

                const formatted = data.map((dept) => ({
                    id: dept.Id,
                    name: dept.Name,
                    guid: dept.DepartmentGUID,
                    status: "Pending",
                }));

                setDepartments(formatted);
            } catch (err) {
                setError("Failed to fetch departments. Please try again later.");
            }
        };

        fetchDepartments();
    }, []);

    return {
        isedit, navigate, assignmentType, setAssignmentType, selectedDepartments, setSelectedDepartments,
        selectedEmployees, setSelectedEmployees, difficulty, setDifficulty, exams, setExams,
        scheduleDate, setScheduleDate, expiryDate, setExpiryDate, oneTimeUsers, setOneTimeUsers,
        confirmOpen, setConfirmOpen, confirmationType, setConfirmationType, successOpen, setSuccessOpen,
        difficulties, setDifficulties, difficultyId, setDifficultyId, isLoading, setIsLoading,
        error, setError, selectedExam, setSelectedExam, selectedExamId, setSelectedExamId,
        departments, setDepartments, assignedData, setAssignedData, assignments, setAssignments,
        selectedAssignmentId, setSelectedAssignmentId, individuals, setIndividuals,
        selectedExamDuration, setSelectedExamDuration, oneTimeEmployees, setOneTimeEmployees
        , workStart, setWorkStart,
        workEnd, setWorkEnd

    };
};

export default useAssignCourse;
